export default "__VITE_ASSET__D5DPCK96__"